const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const colors = require("../util/ColorUtil").getCurrentScheme();

const styles = require("./styles/PieGraph.css");

module.exports = createReactClass({
	displayName: "PieGraph",

	propTypes: {
		className: PT.string.isRequired,
		data: PT.arrayOf(PT.object).isRequired,
		backgroundColor: PT.string,
		innerText: PT.string,
		onClick: PT.func,
	},

	// Colors that need adjusting for printing
	colorMap: {
		[colors.lighterGrayFill]: "lighterGrayFill",
		[colors.lightGrayFill]: "lightGrayFill",
		[colors.correctFill]: "correctFill",
		[colors.white]: "white",
	},

	createSlice(slice, i, rotateOffset) {
		const {percent, color} = slice;
		if (!percent) return null;
		const s = Math.ceil(percent * 100);
		const offset = Math.floor(rotateOffset * 360);
		return (
			<circle
				key={"slice" + i}
				r="16"
				cx="16"
				cy="16"
				stroke={color}
				className={styles[this.colorMap[color]]}
				fill="transparent"
				strokeWidth="32"
				strokeDasharray={s + " " + 100}
				transform={"rotate(" + offset + " 16 16)"}
			/>
		);
	},

	render() {
		const {className, data, backgroundColor, innerText} = this.props;

		let rotateOffset = 0;
		let slices = null;
		if (data.length) {
			slices = data.map((d, i) => {
				const slice = this.createSlice(d, i, rotateOffset);
				rotateOffset += d.percent;
				return slice;
			});
		}

		const text = innerText ? (
			<div className={styles.text}>{innerText}</div>
		) : null;

		// Note: The width/height and radius are 32 and 16 so that we can use
		// percentages out of 100 for slice calculations. Circumference of circle
		// of radius 16 is approx 100.

		return (
			<div
				className={styles.main + " " + className}
				onClick={this.props.onClick}
			>
				<svg
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 32 32"
					width="32"
					height="32"
					preserveAspectRatio="none"
					className={styles.svg}
				>
					<circle
						r="16"
						cx="16"
						cy="16"
						fill={backgroundColor || colors.lightGrayFill}
						className={
							backgroundColor === colors.lightGrayFill || !backgroundColor
								? styles.printGray
								: ""
						}
					/>
					{slices}
				</svg>
				{text}
			</div>
		);
	},
});
